module.exports = __webpack_public_path__ + "files/5fbd0d2f9eee986804831e49dd47e6d2.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/lato-italic-webfont.ttf
// module id = 838
// module chunks = 60